import { useEffect } from 'react'
import maplibregl from 'maplibre-gl'

// Native MapLibre controls: NavigationControl (zoom +/-, compass = reset
// orientation / reset north) and FullscreenControl (Fullscreen API). Added once
// the map exists; removed on unmount. Isolated here per the "MapLibre
// interactions behind specialized hooks" rule.
export function useNativeControls(map) {
  useEffect(() => {
    if (!map.current) return
    const nav = new maplibregl.NavigationControl({
      showZoom: true,
      showCompass: true,     // click resets bearing to north / pitch to 0
      visualizePitch: true,
    })
    const fullscreen = new maplibregl.FullscreenControl()
    map.current.addControl(nav, 'top-right')
    map.current.addControl(fullscreen, 'top-right')
    return () => {
      try { map.current?.removeControl(nav) } catch { /* map already gone */ }
      try { map.current?.removeControl(fullscreen) } catch { /* map already gone */ }
    }
  }, [map])
}
